import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { noControlPersonText } from '../../../constants';
import { ProfileContext } from '../../../context/Profile.context';
import { isControlPersonsTabComplete } from '../../../utils/completes';
import FieldError from '../..//FieldError';
import IndividualControlPerson from './IndividualControlPerson';
import CorporateEntities from './CorporateEntities';

import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, EntityLabelGroup, EntityLabel, Label, TextField, Typography, InfoPanel, SectionTitle, Divider } from '@otcmarketsgroup/otcm-ui-lib';

const ControlPersonTab = ({ onControlPersonAdd, onControlPersonUpdate, onControlPersonListUpdate, onControlPersonRemove }) => {
  const [profileState, dispatchProfile] = useContext(ProfileContext);
  const profile = profileState.profile;
  const controlPersons = profile.controlPersons;
  const individualsList = controlPersons && controlPersons.filter(person => !person.isCorpEntity && !person.isDeleted);
  const hasIndividuals = individualsList && individualsList.length > 0;
  const corporateEntityList = controlPersons && controlPersons.filter((person, index) => (person.corpEntity && !person.hasBeneficialOwners && !person.isDeleted)
    || (person.corpEntity && person.hasBeneficialOwners && controlPersons.findIndex((item) => item.corpEntity === person.corpEntity && !item.isDeleted) === index));
  const hasCorpEntities = corporateEntityList && corporateEntityList.length > 0;
  const isTabComplete = isControlPersonsTabComplete(profile);
  const isReadOnly = profileState.readOnly;

  const onValueChanged = (value, field) => {
    dispatchProfile({
      type: 'UPDATE_PROFILE',
      field: field,
      payload: value
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {!isTabComplete && <InfoPanel isWarning title='At least one person or entity is required. Or select No Control Persons.' />}
      <Typography variant='body1'>
        Enter all persons or entities beneficially owning 10% or more of any class of the issuer's shares; do not include Officers and Directors previously listed.
      </Typography>
      <Typography variant='body1'>
        A Beneficial Shareholder is any person who, directly or indirectly, has or shares the power to vote or dispose of a stock. Beneficial ownership includes the right to acquire the security within 60 days including but not limited to the exercise of options or warrants, or through conversion. See Securities Exchange Act Rule 13d-3.
      </Typography>
      <Box>
        <Checkbox
          sx={{
            '& .MuiFormControlLabel-label': {
              fontWeight: 700,
              fontSize: '1rem',
            },
          }}
          label={noControlPersonText}
          checked={profile.noControlPerson}
          disabled={isReadOnly || (hasIndividuals || hasCorpEntities)}
          onChange={e => onValueChanged(e.target.checked, 'noControlPerson')}
        />
      </Box>
      <IndividualControlPerson
        noControlPerson={profile.noControlPerson}
        onControlPersonAdd={onControlPersonAdd}
        onControlPersonUpdate={onControlPersonUpdate}
        onControlPersonRemove={onControlPersonRemove} />
      <CorporateEntities
        noControlPerson={profile.noControlPerson}
        onControlPersonAdd={onControlPersonAdd}
        onControlPersonUpdate={onControlPersonUpdate}
        onControlPersonListUpdate={onControlPersonListUpdate}
        onControlPersonRemove={onControlPersonRemove}
      />
    </Box>
  );
};

ControlPersonTab.propTypes = {
  onControlPersonAdd: PropTypes.func,
  onControlPersonUpdate: PropTypes.func,
  onControlPersonListUpdate: PropTypes.func,
  onControlPersonRemove: PropTypes.func
};

export default ControlPersonTab;
